import React from 'react';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import styles from './categoryCard.module.scss';

interface IProps {
    image: string,
    title: string,
    onClick: () => void
};

const CategoryCard: React.FC<IProps> = (props) => {
    const { image, title, onClick } = props;
    const { baseURL } = useNoAuthHooks();

    return (
        <div
            onClick={onClick}
            className={styles.card}>
            <div
                className={styles.cardImage}
                style={{ backgroundImage: `url(${baseURL}${image})` }}
            >
                <div className={styles.title}>
                    <p>{title}</p>
                </div>
            </div>
        </div>
    )
}

export default CategoryCard
